/**
 * Mappe une route vers un libellé humain pour le panneau de présence.
 */
const ROUTE_LABELS: { pattern: RegExp; label: string }[] = [
  { pattern: /^\/companies\/[^/]+/, label: "Fiche entreprise" },
  { pattern: /^\/companies$/, label: "Liste des entreprises" },
  { pattern: /^\/users\/[^/]+/, label: "Fiche utilisateur" },
  { pattern: /^\/users$/, label: "Liste des utilisateurs" },
  { pattern: /^\/calendar/, label: "Calendrier" },
  { pattern: /^\/$/, label: "Tableau de bord" },
];

export function labelForRoute(pathname: string): string {
  const match = ROUTE_LABELS.find((r) => r.pattern.test(pathname));
  return match ? match.label : pathname;
}
